"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollableDiv = exports.Overlay = exports.ModalContent = exports.HeaderWrapper = exports.Content = exports.CloseWrapper = exports.ActionButtonWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../globals/styles/breakpoints"));
var _react2 = require("motion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Overlay = exports.Overlay = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt6"
} : {
  target: "e1pqvfqt6",
  label: "Overlay"
})(process.env.NODE_ENV === "production" ? {
  name: "3ficsf",
  styles: "position:fixed;-webkit-overflow-scrolling:touch;top:0;left:0;right:0;bottom:0;z-index:1001;background:rgba(0, 0, 0, 0.27);overflow:auto;height:100%;display:flex;justify-content:center;align-items:center;&.filter-overlay-exit{background:rgba(0, 0, 0, 0);}"
} : {
  name: "3ficsf",
  styles: "position:fixed;-webkit-overflow-scrolling:touch;top:0;left:0;right:0;bottom:0;z-index:1001;background:rgba(0, 0, 0, 0.27);overflow:auto;height:100%;display:flex;justify-content:center;align-items:center;&.filter-overlay-exit{background:rgba(0, 0, 0, 0);}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1oys671",
  styles: "transition:width 200ms,min-height 50ms"
} : {
  name: "fnyawo-Content",
  styles: "transition:width 200ms,min-height 50ms;label:Content;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const Content = exports.Content = /*#__PURE__*/(0, _base.default)("dialog", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt5"
} : {
  target: "e1pqvfqt5",
  label: "Content"
})(({
  width,
  isFullscreen,
  canToggleFullscreen
}) => /*#__PURE__*/(0, _react.css)("position:relative;min-width:300px;width:", isFullscreen ? '100%' : width, ";min-height:", isFullscreen ? '100%' : '100px', ";margin:", isFullscreen ? '0' : '0 1em', ";border-style:none;border-radius:", isFullscreen ? '0' : '15px', ";background-color:#ffffff;box-shadow:0 10px 20px 0 rgba(0, 0, 0, 0.25);padding:unset;", canToggleFullscreen && _ref, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Content;")));
const CloseWrapper = exports.CloseWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt4"
} : {
  target: "e1pqvfqt4",
  label: "CloseWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "2bmjnc",
  styles: "position:absolute;display:flex;top:1.5em;right:2em;opacity:0.3;gap:3px"
} : {
  name: "2bmjnc",
  styles: "position:absolute;display:flex;top:1.5em;right:2em;opacity:0.3;gap:3px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const HeaderWrapper = exports.HeaderWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt3"
} : {
  target: "e1pqvfqt3",
  label: "HeaderWrapper"
})(({
  withCollapse
}) => /*#__PURE__*/(0, _react.css)("padding:1.5em 2em;h1,h2,h3,h4,h5{margin-right:", withCollapse ? '2em' : '1em', ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:HeaderWrapper;")));
const ModalContent = exports.ModalContent = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt2"
} : {
  target: "e1pqvfqt2",
  label: "ModalContent"
})(props => /*#__PURE__*/(0, _react.css)("padding:", props.scrollable ? '0 0 1.5em 0' : '1.5em 2em', ";padding-top:0;" + (process.env.NODE_ENV === "production" ? "" : ";label:ModalContent;")));
const ScrollableDiv = exports.ScrollableDiv = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt1"
} : {
  target: "e1pqvfqt1",
  label: "ScrollableDiv"
})(({
  hasActionButton,
  isFullscreen,
  windowHeight,
  headerHeight
}) => /*#__PURE__*/(0, _react.css)("max-height:calc(\n      ", isFullscreen ? windowHeight + 'px' : '95vh', " -\n        ", hasActionButton ? '200px' : isFullscreen ? `${headerHeight}px - 1.5em - 2px` : '120px', "\n    );overflow-y:auto;-webkit-overflow-scrolling:touch;padding:0 2em;@media screen and (max-width: ", _breakpoints.default.medium, "){max-height:calc(\n        ", windowHeight + 'px', " -\n          ", hasActionButton ? '200px' : isFullscreen ? `${headerHeight}px - 1.5em` : '120px', "\n      );}" + (process.env.NODE_ENV === "production" ? "" : ";label:ScrollableDiv;")));
const ActionButtonWrapper = exports.ActionButtonWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1pqvfqt0"
} : {
  target: "e1pqvfqt0",
  label: "ActionButtonWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1x4nlz1",
  styles: "display:flex;justify-content:flex-end;padding:1.5em 2em;padding-top:1em;border-top:1px solid #d7d7d7"
} : {
  name: "1x4nlz1",
  styles: "display:flex;justify-content:flex-end;padding:1.5em 2em;padding-top:1em;border-top:1px solid #d7d7d7",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});